import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { getSafeData } from './utils';
const CommunityAPIs = {
    async getList(userID, pagination = { offset: 0 }) {
        const { offset = 0, limit = 20 } = pagination;
        const communities = await db.qnaNode
            .where('type')
            .equals(NodeType.COMMUNITY)
            .and(node => !node.deleted)
            .offset(offset)
            .limit(limit)
            .toArray();
        return {
            list: communities.map(getSafeData),
            totalCount: communities.length,
        };
    },
    async getByID(userID, communityID) {
        const community = await db.qnaNode.get(communityID);
        if (!community || community.type !== NodeType.COMMUNITY || community.deleted) {
            throw new Error('Community not found');
        }
        return getSafeData(community);
    },
    getSafeData,
};
export default CommunityAPIs;
